import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import {
  createBodyPlutos,
  uploadImage,
} from "../../../redux/actions/addCampaigndata.js";
import { Add } from "@mui/icons-material";
import { Button, Grid, MenuItem, TextField, Toolbar } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Col, Row } from "react-bootstrap";
import JoditEditor from "jodit-react";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StarRateIcon from '@mui/icons-material/StarRate';
import DeleteIcon from "@mui/icons-material/Delete";
import schemas from "../../Update_Campaign/comman/PlutosHome.js";
import InputFieldOrder from "../comman/InputFieldOrder.jsx";
import { motion } from "framer-motion";



const PlutosHome = (props) => {
  const { handleNext, activeStep, handleBack } = props;
  const uiType = localStorage.getItem("uiType") || "plutoshome";
  const selector = useSelector((state) => state.addCampaignReducer);
  const campaignId = localStorage.getItem("campaignId") ?? selector.campaignId;

  // collapse state
  const [columnVisibility, setColumnVisibility] = useState({
    mainRightBannerDesktop: false,
    mainLeftBannerDesktop: false,
    rechargeLeftBannerDesktop: false,
    rechargeLeftBannerMobile: false,
    rechargeRightBannerDesktop: false,
    rechargeRightBannerMobile: false,
    exclusiveBannerDesktop: false,
    primeLeftBannerDesktop: false,
    primeLeftBannerMobile: false,
    prime_right_banner_desktop: false,
    partners: false,
    coins_banner_desktop: false,
    coins_banner_mobile: false,
    vouchers_desktop: false,
    vouchers_mobile: false,
  });



  const handleUrlChange = (index, logo, e) => {

    const urlValue = e.target.value.trim();

    const validLogos = [
      "main_right_banner_desktop",
      "main_right_banner_mobile",
      "recharge_left_banner_desktop",
      "recharge_left_banner_mobile",
      "recharge_right_banner_desktop",
      "recharge_right_banner_mobile",
      "exclusive_banner_desktop",
      "exclusive_banner_mobile",
      "prime_left_banner_desktop",
      "prime_left_banner_mobile",
      "prime_right_banner_desktop",
      "coins_banner_desktop",
      "coins_banner_mobile",
      "vouchers_desktop",
      "vouchers_mobile"
    ];

    const logoConditions = {
      main_right_banner_desktop: true,
      main_right_banner_mobile: true,
      recharge_left_banner_desktop: true,
      recharge_left_banner_mobile: true,
      recharge_right_banner_desktop: true,
      recharge_right_banner_mobile: true,
      exclusive_banner_desktop: true,
      exclusive_banner_mobile: true,
      prime_left_banner_desktop: true,
      prime_left_banner_mobile: true,
      prime_right_banner_desktop: true,
      coins_banner_desktop: true,
      coins_banner_mobile: true,
      vouchers_desktop: true,
      vouchers_mobile: true
    };

    const isValidLogo = logoConditions[logo];

    if (isValidLogo && validLogos.includes(logo)) {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].image`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);

    } else if (logo === "partners") {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].logo`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);
    }
  };


  const toggleColumn = (columnName) => {
    setColumnVisibility({
      ...columnVisibility,
      [columnName]: !columnVisibility[columnName],
    });
  };

  const dispatch = useDispatch();

  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
    clearErrors,
    setError,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schemas),

    defaultValues: {
      rechange_heading: "",
      rechange_subHeading: "",
      exclusive_heading: "",
      exclusive_subHeading: "",
      prime_heading: "",
      prime_subHeading: "",
      coins_heading: "",
      coins_subHeading: "",
      partners_subHeading: "",
      uiType: "",
      disclaimer: "",
      main_right_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      main_right_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      recharge_left_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      recharge_left_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      recharge_right_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      recharge_right_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      exclusive_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      exclusive_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      prime_left_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      prime_left_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      prime_right_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      coins_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      coins_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      vouchers_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      vouchers_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      partners: [{ file: null, order: "" }],
    },
  });


  console.log(errors, "errors")



  const {
    fields: photoFields,
    append: appendPhoto,
    remove: removePhoto,
  } = useFieldArray({
    control,
    name: "main_right_banner_mobile",
  });

  const {
    fields: rechargeFields,
    append: appendRechargePhoto,
    remove: removeRechargePhoto,
  } = useFieldArray({
    control,
    name: "recharge_left_banner_desktop",
  });

  const {
    fields: rechargeFieldsMobile,
    append: appendRechargeMobile,
    remove: removeRechargeMobile,
  } = useFieldArray({
    control,
    name: "recharge_left_banner_mobile",
  });

  const {
    fields: rechargeFieldsRightDesktop,
    append: appendRechargeRightDesktop,
    remove: removeRechargeRightDesktop,
  } = useFieldArray({
    control,
    name: "recharge_right_banner_desktop",
  });

  const {
    fields: rechargeFieldsRightMobile,
    append: appendRechargeRightMobile,
    remove: removeRechargeRightMobile,
  } = useFieldArray({
    control,
    name: "recharge_right_banner_mobile",
  });

  const {
    fields: exclusiveFieldsDesktop,
    append: appendExclusiveDesktop,
    remove: removeExclusiveDesktop,
  } = useFieldArray({
    control,
    name: "exclusive_banner_desktop",
  });

  const {
    fields: exclusiveFieldsMobile,
    append: appendExclusiveMobile,
    remove: removeExclusiveMobile,
  } = useFieldArray({
    control,
    name: "exclusive_banner_mobile",
  });

  const {
    fields: primeFieldsDesktop,
    append: appendPrimeDesktop,
    remove: removePrimeDesktop,
  } = useFieldArray({
    control,
    name: "prime_left_banner_desktop",
  });


  const {
    fields: primeFieldsMobile,
    append: appendPrimeMobile,
    remove: removePrimeMobile,
  } = useFieldArray({
    control,
    name: "prime_left_banner_mobile",
  });


  const {
    fields: primeFieldRightDesktop,
    append: appendPrimeRightDesktop,
    remove: removePrimeRightDesktop,
  } = useFieldArray({
    control,
    name: "prime_right_banner_desktop",
  });


  const {
    fields: coinsFieldsDesktop,
    append: appendCoinsDesktop,
    remove: removeCoinsDesktop,
  } = useFieldArray({
    control,
    name: "coins_banner_desktop",
  });


  const {
    fields: coinsFieldsMobile,
    append: appendCoinsMobile,
    remove: removeCoinsMobile,
  } = useFieldArray({
    control,
    name: "coins_banner_mobile",
  });

  const {
    fields: VouchersMobileFields,
    append: appendVouchersMobile,
    remove: removeVouchersMobile,
  } = useFieldArray({
    control,
    name: "vouchers_mobile",
  });


  const {
    fields: VouchersDesktopFields,
    append: appendVouchersDesktop,
    remove: removeVouchersDesktop,
  } = useFieldArray({
    control,
    name: "vouchers_desktop",
  });

  const {
    fields: partnersFields,
    append: partnersAppend,
    remove: partnersRemove,
  } = useFieldArray({
    control,
    name: "partners",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "main_right_banner_desktop",
  });

  const handleEditor = (value) => {
    if (value === "") {
      setError("enter the disclaimer");
    } else {
      setValue("disclaimer", value);
      setError("");
    }
  };

  const handleImage = async (index, logo, e) => {
    const file = e.target.files[0];
    const isImage = file && file.type.startsWith("image/");
    const formData = new FormData();
    formData.append("image", file);
    if (logo === "main_right_banner_desktop") {
      clearErrors(`main_right_banner_desktop[${index}].image`);
      if (!isImage) {
        setError(`main_right_banner_desktop[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`main_right_banner_desktop[${index}].image`, res);
          setValue(`main_right_banner_desktop[${index}].file`, res);
        });
      }
    } else if (logo === "main_right_banner_mobile") {
      clearErrors(`main_right_banner_mobile[${index}].image`);
      if (!isImage) {
        setError(`main_right_banner_mobile[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`main_right_banner_mobile[${index}].image`, res);
          setValue(`main_right_banner_mobile[${index}].file`, res);
        });
      }
    } else if (logo === "recharge_left_banner_desktop") {
      clearErrors(`recharge_left_banner_desktop[${index}].file`);
      if (!isImage) {
        setError(`recharge_left_banner_desktop[${index}].file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`recharge_left_banner_desktop[${index}].image`, res);
          setValue(`recharge_left_banner_desktop[${index}].file`, res);
        });
      }
    } else if (logo === "recharge_left_banner_mobile") {
      clearErrors(`recharge_left_banner_mobile[${index}].image`);
      if (!isImage) {
        setError(`recharge_left_banner_mobile[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`recharge_left_banner_mobile[${index}].image`, res);
          setValue(`recharge_left_banner_mobile[${index}].file`, res);
        });
      }
    } else if (logo === "recharge_right_banner_desktop") {
      clearErrors(`recharge_right_banner_desktop[${index}].file`);
      if (!isImage) {
        setError(`recharge_right_banner_desktop[${index}].file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`recharge_right_banner_desktop[${index}].image`, res);
          setValue(`recharge_right_banner_desktop[${index}].file`, res);
        });
      }
    } else if (logo === "recharge_right_banner_mobile") {
      clearErrors(`recharge_right_banner_mobile[${index}].image`);
      if (!isImage) {
        setError(`recharge_right_banner_mobile[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`recharge_right_banner_mobile[${index}].image`, res);
          setValue(`recharge_right_banner_mobile[${index}].file`, res);
        });
      }
    } else if (logo === "exclusive_banner_desktop") {
      clearErrors(`exclusive_banner_desktop[${index}].image`);
      if (!isImage) {
        setError(`exclusive_banner_desktop[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`exclusive_banner_desktop[${index}].image`, res);
          setValue(`exclusive_banner_desktop[${index}].file`, res);
        });
      }
    } else if (logo === "exclusive_banner_mobile") {
      clearErrors(`exclusive_banner_mobile[${index}].image`);
      if (!isImage) {
        setError(`exclusive_banner_mobile[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`exclusive_banner_mobile[${index}].image`, res);
          setValue(`exclusive_banner_mobile[${index}].file`, res);
        });
      }
    } else if (logo === "prime_left_banner_desktop") {
      clearErrors(`prime_left_banner_desktop[${index}].image`);
      if (!isImage) {
        setError(`prime_left_banner_desktop[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`prime_left_banner_desktop[${index}].image`, res);
          setValue(`prime_left_banner_desktop[${index}].file`, res);
        });
      }
    } else if (logo === "prime_left_banner_mobile") {
      clearErrors(`prime_left_banner_mobile[${index}].image`);
      if (!isImage) {
        setError(`prime_left_banner_mobile[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`prime_left_banner_mobile[${index}].image`, res);
          setValue(`prime_left_banner_mobile[${index}].file`, res);
        });
      }
    } else if (logo === "prime_right_banner_desktop") {
      clearErrors(`prime_right_banner_desktop[${index}].image`);
      if (!isImage) {
        setError(`prime_right_banner_desktop[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`prime_right_banner_desktop[${index}].image`, res);
          setValue(`prime_right_banner_desktop[${index}].file`, res);
        });
      }
    } else if (logo === "coins_banner_desktop") {
      clearErrors(`coins_banner_desktop[${index}].image`);
      if (!isImage) {
        setError(`coins_banner_desktop[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`coins_banner_desktop[${index}].image`, res);
          setValue(`coins_banner_desktop[${index}].file`, res);
        });
      }
    } else if (logo === "coins_banner_mobile") {
      clearErrors(`coins_banner_mobile[${index}].image`);
      if (!isImage) {
        setError(`coins_banner_mobile[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`coins_banner_mobile[${index}].image`, res);
          setValue(`coins_banner_mobile[${index}].file`, res);
        });
      }
    } else if (logo === "vouchers_desktop") {
      clearErrors(`vouchers_desktop[${index}].image`);
      if (!isImage) {
        setError(`vouchers_desktop[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`vouchers_desktop[${index}].image`, res);
          setValue(`vouchers_desktop[${index}].file`, res);
        });
      }
    } else if (logo === "vouchers_mobile") {
      clearErrors(`vouchers_mobile[${index}].image`);
      if (!isImage) {
        setError(`vouchers_mobile[${index}].image`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`vouchers_mobile[${index}].image`, res);
          setValue(`vouchers_mobile[${index}].file`, res);
        });
      }
    } else if (logo === "partners") {
      clearErrors(`partners[${index}].logo`);
      if (!isImage) {
        setError(`partners[${index}].file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`partners[${index}].logo`, res);
          setValue(`partners[${index}].file`, res);
        });
      }
    }
  };

  const user = localStorage.getItem("userID");

  const onSubmit = async (data) => {
    const recreatedDesktopArray = data.main_right_banner_desktop.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const recreatedDesktopArrayRecharge = data.recharge_left_banner_desktop.map(
      (item) => {
        const { file, ...newItem } = item;
        return newItem;
      }
    );

    const recreatedDesktopArrayRechargeMobile =
      data.recharge_left_banner_mobile.map((item) => {
        const { file, ...newItem } = item;
        return newItem;
      });

    const recreatedDesktopArrayRechargeRightDesktop =
      data.recharge_right_banner_desktop.map((item) => {
        const { file, ...newItem } = item;
        return newItem;
      });

    const recreatedDesktopArrayRechargeRightMobile =
      data.recharge_right_banner_mobile.map((item) => {
        const { file, ...newItem } = item;
        return newItem;
      });

    const recreatedExclusiveDesktop = data.exclusive_banner_desktop.map(
      (item) => {
        const { file, ...newItem } = item;
        return newItem;
      }
    );
    const recreatedExclusiveMobile = data.exclusive_banner_mobile.map(
      (item) => {
        const { file, ...newItem } = item;
        return newItem;
      }
    );
    const recreatedPrimeLeftDesktop = data.prime_left_banner_desktop.map(
      (item) => {
        const { file, ...newItem } = item;
        return newItem;
      }
    );
    const recreatedPrimeLeftMobile = data.prime_left_banner_mobile.map(
      (item) => {
        const { file, ...newItem } = item;
        return newItem;
      }
    );
    const recreatedPrimeRightDesktop = data.prime_right_banner_desktop.map(
      (item) => {
        const { file, ...newItem } = item;
        return newItem;
      }
    );
    const recreatedCoinsDesktop = data.coins_banner_desktop.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const recreatedCoinsMobile = data.coins_banner_mobile.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const recreatedVouchersDesktop = data.vouchers_desktop.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const recreatedVouchersMobile = data.vouchers_mobile.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const recreatedPartners = data.partners.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const recreatedMobileArray = data.main_right_banner_mobile.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const recreatedData = {
      ...data,
      main_right_banner_desktop: recreatedDesktopArray,
      main_right_banner_mobile: recreatedMobileArray,
      recharge_left_banner_desktop: recreatedDesktopArrayRecharge,
      recharge_left_banner_mobile: recreatedDesktopArrayRechargeMobile,
      recharge_right_banner_desktop: recreatedDesktopArrayRechargeRightDesktop,
      recharge_right_banner_mobile: recreatedDesktopArrayRechargeRightMobile,
      exclusive_banner_desktop: recreatedExclusiveDesktop,
      exclusive_banner_mobile: recreatedExclusiveMobile,
      prime_left_banner_desktop: recreatedPrimeLeftDesktop,
      prime_left_banner_mobile: recreatedPrimeLeftMobile,
      prime_right_banner_desktop: recreatedPrimeRightDesktop,
      coins_banner_desktop: recreatedCoinsDesktop,
      coins_banner_mobile: recreatedCoinsMobile,
      vouchers_desktop: recreatedVouchersDesktop,
      vouchers_mobile: recreatedVouchersMobile,
      partners: recreatedPartners,
      created_by: user,
      campaignId: data.campaignId || localStorage.getItem("updateID")
    };

    const result = await dispatch(createBodyPlutos(recreatedData));
    if (result?.success === true) {
      handleNext();
    }
  };

  useEffect(() => {
    if (uiType !== null && uiType !== undefined) {
      setValue("uiType", uiType);
    }
    if (campaignId !== null && campaignId !== undefined) {
      setValue("campaignId", campaignId);
    }
  }, [uiType, campaignId]);



  return (
    <div>
      <div className="">
        <form onSubmit={handleSubmit(onSubmit)}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="text-center fw-bold mb-3 border-bottom border-2 border-info pb-1"
            style={{ fontSize: "20px", color: "rgba(0, 165, 162, 0.9)" }}
          >
             Plutos Home Body Section
          </motion.div>
          <div className="container">
            <Row>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('mainRightBannerDesktop')}>
                  Main Right Banner Desktop <StarRateIcon />  {columnVisibility.mainRightBannerDesktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.mainRightBannerDesktop ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`main_right_banner_desktop`}
                    errors={errors}
                    remove={remove}
                    fieldsArray={fields}
                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    appendfunc={append}
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('mainLeftBannerDesktop')}>
                  Main Right Banner Mobile  <StarRateIcon />  {columnVisibility.mainLeftBannerDesktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.mainLeftBannerDesktop ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`main_right_banner_mobile`}
                    errors={errors}
                    remove={removePhoto}
                    fieldsArray={photoFields}
                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    appendfunc={appendPhoto}
                  />
                </div>
                <hr />
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('rechargeLeftBannerDesktop')}>
                  Recharge Left Banner Desktop  <StarRateIcon />  {columnVisibility.rechargeLeftBannerDesktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.rechargeLeftBannerDesktop ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`recharge_left_banner_desktop`}
                    appendfunc={appendRechargePhoto}
                    remove={removeRechargePhoto}
                    fieldsArray={rechargeFields}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('rechargeLeftBannerMobile')}>
                  Recharge Left Banner Mobile  <StarRateIcon />  {columnVisibility.rechargeLeftBannerMobile ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.rechargeLeftBannerMobile ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`recharge_left_banner_mobile`}
                    appendfunc={appendRechargeMobile}
                    remove={removeRechargeMobile}
                    fieldsArray={rechargeFieldsMobile}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('rechargeRightBannerDesktop')}>
                  Recharge Right Banner Desktop  <StarRateIcon />  {columnVisibility.rechargeRightBannerDesktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.rechargeRightBannerDesktop ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`recharge_right_banner_desktop`}
                    appendfunc={appendRechargeRightDesktop}
                    remove={removeRechargeRightDesktop}
                    fieldsArray={rechargeFieldsRightDesktop}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('rechargeRightBannerMobile')}>
                  Recharge Right Banner Mobile  <StarRateIcon />  {columnVisibility.rechargeRightBannerMobile ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.rechargeRightBannerMobile ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`recharge_right_banner_mobile`}
                    appendfunc={appendRechargeRightMobile}
                    remove={removeRechargeRightMobile}
                    fieldsArray={rechargeFieldsRightMobile}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('exclusiveBannerDesktop')}>
                  Exclusive Banner Desktop   <StarRateIcon />  {columnVisibility.exclusiveBannerDesktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.exclusiveBannerDesktop ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`exclusive_banner_desktop`}
                    appendfunc={appendExclusiveDesktop}
                    remove={removeExclusiveDesktop}
                    fieldsArray={exclusiveFieldsDesktop}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('exclusiveBannerMobile')}>
                  Exclusive Banner Mobile   <StarRateIcon />  {columnVisibility.exclusiveBannerMobile ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.exclusiveBannerMobile ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`exclusive_banner_mobile`}
                    appendfunc={appendExclusiveMobile}
                    remove={removeExclusiveMobile}
                    fieldsArray={exclusiveFieldsMobile}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col lg={3}>
                <div className="column mt-2">
                  <TextField
                    type="text"
                    {...register(`rechange_heading`)}
                    className={`form-control mb-3 ${errors.rechange_heading ? "error" : ""
                      }`}
                    label="Enter Recharge Heading"
                  />
                </div>
              </Col>
              <Col lg={3}>
                <div className="column mt-2">
                  <TextField
                    type="text"
                    {...register(`rechange_subHeading`)}
                    className={`w-100 mb-3 ${errors.rechange_subHeading ? "error" : ""
                      }`}
                    label="Enter Recharge Sub Heading "
                  />
                </div>
              </Col>
              <Col lg={3}>
                <div className="column mt-2">
                  <TextField
                    type="text"
                    {...register(`exclusive_heading`)}
                    className={`w-100 mb-2 ${errors.exclusive_heading ? "error" : ""
                      }`}
                    label="Enter Exclusive Heading"
                  />
                </div>
              </Col>
              <Col lg={3}>
                <div className="column mt-2">
                  <TextField
                    type="text"
                    {...register(`exclusive_subHeading`)}
                    className={`w-100 mb-2 ${errors.exclusive_subHeading ? "error" : ""
                      }`}
                    label="Enter Exclusive Sub-Heading"
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                {" "}
                <div className="column">
                  <TextField
                    type="text"
                    {...register(`prime_heading`)}
                    className={`w-100 mb-2 ${errors.prime_heading ? "error" : ""
                      }`}
                    label="Enter Prime Heading"
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="column">
                  <TextField
                    type="text"
                    {...register(`prime_subHeading`)}
                    className={`w-100 mb-2 ${errors.prime_subHeading ? "error" : ""
                      }`}
                    label="Enter Prime Sub-Heading"
                  />
                </div>
                <hr />
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('primeLeftBannerDesktop')}>
                  Prime Left Banner Desktop   <StarRateIcon />  {columnVisibility.primeLeftBannerDesktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.primeLeftBannerDesktop ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`prime_left_banner_desktop`}
                    appendfunc={appendPrimeDesktop}
                    remove={removePrimeDesktop}
                    fieldsArray={primeFieldsDesktop}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('primeLeftBannerMobile')}>
                  Prime Left Banner Mobile   <StarRateIcon />  {columnVisibility.primeLeftBannerMobile ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.primeLeftBannerMobile ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`prime_left_banner_mobile`}
                    appendfunc={appendPrimeMobile}
                    remove={removePrimeMobile}
                    fieldsArray={primeFieldsMobile}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('prime_right_banner_desktop')}>
                  Prime Right Banner Desktop   <StarRateIcon />  {columnVisibility.prime_right_banner_desktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.prime_right_banner_desktop ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`prime_right_banner_desktop`}
                    appendfunc={appendPrimeRightDesktop}
                    remove={removePrimeRightDesktop}
                    fieldsArray={primeFieldRightDesktop}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('partners')}>
                  Partners  <StarRateIcon />  {columnVisibility.partners ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.partners ? 'block' : 'none' }}>
                  {partnersFields.map((item, index) => (
                    <div key={item.id} className="form-row ">
                      <div className="d-flex justify-content-around mb-3 mt-2">
                        <Button
                          variant="contained"
                          component="label"
                          {...register(`partners.file`)}
                          onClick={() => clearErrors(`partners.file`)} // Clear errors for URL when file input is clicked
                        >
                          Upload File
                          <input
                            type="file"
                            {...register(`partners.file`)}
                            hidden
                            onChange={(e) => handleImage(index, "partners", e)}
                            className={`file_button mb-1 ${errors.partners && errors?.partners?.file ? "error" : ""}`}
                          />
                        </Button>
                        {watch(`partners[${index}].logo`) && (
                          <div className="image_div">
                            <img
                              src={watch(`partners[${index}].logo`)}
                              alt=""
                              width={100}
                              height="auto"
                              className="rounded image"
                            />
                          </div>
                        )}
                      </div>
                      <div className="column">
                        <Controller
                          name={`partners[${index}].file`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Banner Url"
                              className={`form-control mb-3 ${errors.partners &&
                                errors?.partners[index]?.file
                                ? "error"
                                : ""
                                }`}
                              value={field.value || ""}
                              onChange={(e) => handleUrlChange(index, "partners", e)}
                            />
                          )}
                        />
                        <Controller
                          name={`partners[${index}].order`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Order"
                              select
                              className={`form-control mb-2 ${errors.partners &&
                                errors?.partners[index]?.order
                                ? "error"
                                : ""
                                }`}
                            >
                              {[...Array(10).keys()].map((number) => (
                                <MenuItem
                                  key={number + 1}
                                  value={(number + 1).toString()}
                                >
                                  {number + 1}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                      </div>
                      <div className="d-flex justify-content-end">
                        {partnersFields.length > 0 &&
                          <DeleteIcon onClick={() => partnersRemove(index)} style={{ color: "red", cursor: "pointer" }} />
                        }
                      </div>
                    </div>
                  ))}
                  <div className="form-row">
                    <Grid className="d-flex justify-content-between">
                      <Toolbar className="p-0">
                        <Button
                          className="button "
                          variant="contained"
                          disableElevation
                          startIcon={<Add />}
                          onClick={() =>
                            partnersAppend({
                              file: null,
                              link: "",
                              target: "",
                              order: "",
                              alt: "",
                            })
                          }
                        >
                          Upload more
                        </Button>
                      </Toolbar>
                    </Grid>
                  </div>
                </div>
                <hr />
                <div className="column">
                  <TextField
                    type="text"
                    {...register(`partners_heading`)}
                    className={`form-control mb-2 ${errors.partners_heading ? "error" : ""
                      }`}
                    label="Enter Partners Heading"
                  />
                </div>
                <div className="column">
                  <TextField
                    type="text"
                    {...register(`partners_subHeading`)}
                    className={`form-control mb-2 ${errors.partners_subHeading ? "error" : ""
                      }`}
                    label="Enter Partners Sub-Heading"
                  />
                </div>
                <hr />
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('coins_banner_desktop')}>
                  Coins Banner Desktop  <StarRateIcon />  {columnVisibility.coins_banner_desktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.coins_banner_desktop ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`coins_banner_desktop`}
                    appendfunc={appendCoinsDesktop}
                    remove={removeCoinsDesktop}
                    fieldsArray={coinsFieldsDesktop}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('coins_banner_mobile')}>
                  Coins Banner Mobile  <StarRateIcon />  {columnVisibility.coins_banner_mobile ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.coins_banner_mobile ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`coins_banner_mobile`}
                    appendfunc={appendCoinsMobile}
                    remove={removeCoinsMobile}
                    fieldsArray={coinsFieldsMobile}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col lg={6}>
                <div>
                  <TextField
                    type="text"
                    {...register(`coins_heading`)}
                    className={`form-control mb-2 ${errors.coins_heading ? "error" : ""
                      }`}
                    label="Enter Coins Heading"
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                {" "}
                <div className="column">
                  <TextField
                    type="text"
                    {...register(`coins_subHeading`)}
                    className={`form-control mb-2 ${errors.coins_subHeading ? "error" : ""
                      }`}
                    label="Enter Coins Heading"
                  />
                </div>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="column">
                  <JoditEditor
                    ref={register(`disclaimer`)}
                    onChange={handleEditor}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3 mt-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('vouchers_desktop')}>
                  Vouchers Desktop  <StarRateIcon />  {columnVisibility.vouchers_desktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.vouchers_desktop ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`vouchers_desktop`}
                    appendfunc={appendVouchersDesktop}
                    remove={removeVouchersDesktop}
                    fieldsArray={VouchersDesktopFields}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="toggle_btn buttons rounded-2 fw-bolder mb-3 mt-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('vouchers_mobile')}>
                  Vouchers Mobile  <StarRateIcon />  {columnVisibility.vouchers_mobile ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.vouchers_mobile ? 'block' : 'none' }}>
                  <InputFieldOrder
                    fieldName={`vouchers_mobile`}
                    appendfunc={appendVouchersMobile}
                    remove={removeVouchersMobile}
                    fieldsArray={VouchersMobileFields}

                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr />
              </Col>
            </Row>
            <Grid className="d-flex gap-2 justify-content-between">
              <Toolbar className="p-0">
                <Button
                  // color="inherit"
                  className="button "
                  variant="contained"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
              </Toolbar>
              <Toolbar className="p-0">
                <Button
                  className="button "
                  variant="contained"
                  disableElevation
                  endIcon={<NavigateNextIcon />}
                  type="submit"
                // onClick={handleNext}
                >
                  Save & Next
                </Button>
              </Toolbar>
            </Grid>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PlutosHome;
